<template>
  <div class="pk-book-view pk-flex">
    <div class="pk-book-view-body-wrapper pk-flex__1">
      <div class="pk-book-view-body pk-flex">
        <div class="pk-flex__1"
         style="height:100%">
          <div class="pk-book-body-col">
            <deepzoom-view v-if="itemLeft"
             :inputData="itemLeft"></deepzoom-view>
          </div>
        </div>
        <div class="pk-page-spacing-flex"></div>
        <div class="pk-flex__1"
         style="height:100%">
          <div class="pk-book-body-col">
            <deepzoom-view v-if="itemRight"
             :inputData="itemRight"></deepzoom-view>
          </div>
        </div>
      </div>
    </div>

    <div class="pk-book-view-footer pk-flex__h-center pk-flex__00auto">
      <div>{{min}}</div>
      <img src="../../assets/icons/first.svg"
       @click="currentIdx=0">
      <img src="../../assets/icons/previous.svg"
       @click="currentIdx>0 ? --currentIdx : ''">
      <div class="pk-book-view__label-current">{{labelCurrent}}</div>
      <img src="../../assets/icons/next.svg"
       @click="currentIdx<(imageList.length-2) ? ++currentIdx : ''">
      <img src="../../assets/icons/last.svg"
       @click="currentIdx=imageList.length-2;">
      <div>{{max}}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import DeepzoomView from '../../components/DeepzoomView';

export default Vue.extend({
  props: {
    inputData: Array
  },
  data() {
    return {
      currentIdx: 0,
    };
  },
  components: {
    'deepzoom-view': DeepzoomView
  },

  computed: {
    imageList() {
      return this.inputData;
    },

    itemLeft() {
      if (!this.imageList) {
        return 0;
      }
      return this.imageList[this.currentIdx];
    },
    itemRight() {
      if (!this.imageList || this.imageList.length < (this.currentIdx + 1)) {
        return;
      }
      return this.imageList[this.currentIdx + 1];
    },
    min() {
      if (!this.imageList) {
        return 0;
      }
      return '01';
    },
    max() {
      if (!this.imageList) {
        return 0;
      }
      const l = this.imageList.length;
      return l > 9 ? l : ('0' + l);
    },
    labelCurrent() {
      if (!this.imageList) {
        return '';
      }
      const i1 = this.currentIdx + 1;
      const i2 = i1 + 1;
      return(i1 > 9 ? i1 : ('0' + i1)) + ' - ' + (i2 > 9 ? i2 : ('0' + i2));
    }
  }

});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

$toolbarHeight:30px;
$labelWidth: 30px;
$buttonWidth: 30px;
.pk-book-view {
  height: 100%;
  width: 100%;
  flex-direction: column;
  position: relative;
}

.pk-book-view-body-wrapper {
  position: relative;
}

.pk-book-view-body {
  position: absolute;
  height: 100%;
  width: 100%;
}

.pk-book-body-col {
  position: relative;
  height: 100%;
  border: 5px solid #ddd;
  padding: 20px;
  width: 100%;
}

.pk-book-view-img {
  max-height: 100%;
  max-width: 100%;
}

.pk-book-view-footer {
  * {
    height: $toolbarHeight;
    margin: 5px;
    text-align: center;
    flex: 0 0 auto;
  }
  div {
    height: $toolbarHeight;
    width: $labelWidth;
    @extend .pk-flex__vh-center;
    background-color: #eee;
    border-radius: 2px;
  }
  .pk-book-view__label-current {
    width: $labelWidth*2.5;
  }
  img {
    width: $buttonWidth;
    &:hover {
      background-color: #eee;
      cursor: pointer;
    }
  }
}
</style>